import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full relative z-10 bg-black border-t border-gray-800" data-id="element-243">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-244">
        {/* Copyright */}
        <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-245">
          <p className="text-gray-600 text-[10px] mb-1" data-id="element-246">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-[10px] mb-1" data-id="element-247">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-248">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-249">
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-250">
              Términos
            </Link>
            <span className="text-gray-600" data-id="element-251">|</span>
            <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-252">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}